// test812
(812 && 0);
